<!-- Novo pedir.delivery (controlado por restaurant.info.modules.new_home_pedir_delivery) -->
<ng-container *ngIf="isNewHomePedirDelivery">
	<section class="recommended">
		<h2 class="recommended__title" translate>Order again</h2>
		<div class="recommended__list">
			<div
				*ngFor="let product of recommendedProducts"
				class="recommended__card"
				(click)="goToShoppingCart(product)"
			>
				<div class="recommended__card-image-wrap">
					<img
						*ngIf="product.image"
						class="recommended__card-image"
						[src]="imgURL + '/products/' + product.image + '/thumb_' + product.image + '.jpg'"
						[alt]="product.name"
						loading="lazy"
					/>
					<div *ngIf="!product.image" class="recommended__card-placeholder" aria-hidden="true"></div>
				</div>
				<div class="recommended__card-content">	
					<p class="recommended__card-name" title="{{ product.name }}">{{ product.name }}</p>
					<span class="recommended__card-price">{{ product.subTotal | multiCurrency }}</span>
				</div>
			</div>
		</div>
	</section>
</ng-container>

<!-- Layout antigo (Ionic) – quando new_home_pedir_delivery não estiver ativo -->
<ng-container *ngIf="!isNewHomePedirDelivery">
	<div class="mt-4">
		<div class="order-again" translate>
			Order again
		</div>
		<div class="container">
			<div class="show-recommended-products-card--list">
				<div
					*ngFor="let product of recommendedProducts"
					class="mp-card col-md-3 col-4 show-recommended-products-card--card"
					(click)="goToShoppingCart(product)"
				>
					<span class="mp-label">
						<mp-img *ngIf="product.image" imgURL="{{imgURL}}/products/{{product.image}}/thumb_{{product.image}}.jpg"></mp-img>
					</span>
					<p class="show-recommended-products-card--title text-lg mt-2">
						{{product.name}}
					</p>
					<h4 class="show-recommended-products-card--price">
						{{product.subTotal | multiCurrency}}
					</h4>
				</div>
			</div>
		</div>
	</div>
</ng-container>
